<template>
  <List :locations="locations"> </List>
</template>

<script>
import imageService from "../../AdImage/service.js";
import List from "../components/Commercial/ClickList";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      locations: []
    };
  },
  created() {
    this.clickImageListByOrg();
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"])
  },
  methods: {
    clickImageListByOrg() {
      return imageService
        .clickImageListByOrg(this.currentOrganization.organizationID)
        .then(response => {
          console.log("response", response);
          this.locations = response.data;
          return response;
        });
    }
  },
  components: {
    List
  }
};
</script>

<style scoped></style>
